import React, { useEffect, useState, useRef } from 'react';
import { animate, useInView } from 'framer-motion';
import { FaCalendarAlt, FaClipboardCheck, FaUsers, FaHardHat } from 'react-icons/fa';
import './Counter.css';

const StatItem = ({ icon, target, label, suffix = "+" }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  useEffect(() => {
    if (isInView) {
      const controls = animate(0, target, {
        duration: 2,
        onUpdate: (value) => setCount(Math.floor(value)),
      });
      return () => controls.stop();
    }
  }, [isInView, target]);

  return (
    <div className="stat-item" ref={ref}>
      <div className="stat-icon">{icon}</div>
      <div className="stat-number">
        {count}
        <span>{suffix}</span>
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

const Counter = () => {
  return (
    <section className="counter-section">
      <div className="container">
        <div className="counter-grid">
          <StatItem 
            icon={<FaCalendarAlt />} 
            target={15} 
            label="Years Experience" 
          />
          <StatItem 
            icon={<FaClipboardCheck />} 
            target={120} 
            label="Projects Completed" 
          />
          <StatItem 
            icon={<FaUsers />} 
            target={500} 
            label="Happy Clients" 
          />
          <StatItem 
            icon={<FaHardHat />} 
            target={12} 
            label="Ongoing Projects" 
          />
        </div>
      </div>
    </section>
  );
};

export default Counter;
